module.exports = __webpack_public_path__ + "static/media/favicon.eb6d1121.ico";